import { GetServiceReviewsUseCase, GetServiceReviewsParams } from "./index"
import { ServiceReview } from "../../../entities/ServiceReview"
import { ServiceReviewsRepository } from "../../../repositories/serviceReviewsRepository"

export class GetServiceReviewsUseCaseImpl implements GetServiceReviewsUseCase {
	private _serviceReviewsRepository: ServiceReviewsRepository

	constructor({ ServiceReviewsRepository }: { ServiceReviewsRepository: ServiceReviewsRepository }) {
		this._serviceReviewsRepository = ServiceReviewsRepository
	}

	async exec(params: GetServiceReviewsParams): Promise<ServiceReview[]> {
		return await this._serviceReviewsRepository.getServiceReviews(params.serviceId, params.pagination, params.limit)
	}
}
